import React from "react";
import styled from "styled-components";

import BlobLoader from "./BlobLoader";

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 40vh;
  margin-top: 20vh;
  padding: 2rem 1rem;
`;

/**
 * Global page loader — animated blob with "Loading..." label.
 * Props are forwarded to BlobLoader (color, textColor, size, showLoadingText).
 */
const Loader = ({
  color = "#00567a",
  textColor = "#00567a",
  size = 200,
  showLoadingText = true,
}) => {
  return (
    <Layout data-testid="global-loader">
      <BlobLoader
        color={color}
        textColor={textColor}
        size={size}
        showLoadingText={showLoadingText}
      />
    </Layout>
  );
};

export default Loader;
